// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3Tmgv","label":"SetPasswdForm_label__3gX6r"};